export const CONTACT_EMAIL = "vintagevantageapp@gmail.com";

// Opens the sender's email app addressed to the shared Vintage Vantage inbox.
export const contactMailto = (subject = "Vintage Vantage — hello") =>
  `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;
